import {HttpClient} from "@angular/common/http";
import {Injectable, signal, WritableSignal} from '@angular/core';
import {toSignal} from "@angular/core/rxjs-interop";
import {HistoryAction, StrokeHistory, UserCursor} from "@app/review/models";
import {MessageType, WebSocketService} from "@app/websocket/websocket.service";
import {Subject} from "rxjs";
import {filter} from "rxjs/operators";


@Injectable({
    providedIn: 'root'
})
export class StageService {
    private _stageSubject = new Subject<UserCursor>();
    private _historySubject = new Subject<StrokeHistory>();

    public stage$ = this._stageSubject.asObservable();
    public historySignal = toSignal(this._historySubject.asObservable(), {initialValue: new StrokeHistory()});
    public assetChangedSignal: WritableSignal<number>;

    constructor(
        private websocketService: WebSocketService,
        private http: HttpClient,
    ) {
        this.websocketService.message$
            .pipe(
                filter((message) => {
                    return message.Type === MessageType.UserCursor ||
                        message.Type === MessageType.StrokeHistory
                }),
            )
            .subscribe((message) => {
                switch (message.Type) {
                    case MessageType.UserCursor:
                        this._stageSubject.next(message as UserCursor);
                        break;
                    case MessageType.StrokeHistory:
                        this._historySubject.next(message as StrokeHistory);
                        break;
                }
            });

        this.assetChangedSignal = signal(performance.now());
    }

    updateRemoteStroke(remoteStroke: any) {
        this._stageSubject.next(remoteStroke);
    }

    resetStage() {
        const strokeHistory = new StrokeHistory();
        strokeHistory.Action = HistoryAction.Clear;
        this._historySubject.next(strokeHistory);

        // This is only called from reviewComponent when setting a new asset
        this.assetChangedSignal.set(performance.now());
    }
}
